export default __webpack_public_path__ + "static/media/dma.508cda3c.csv";